import { Formik, Form, Field } from 'formik';
import InputMask from 'react-input-mask';
import { TimedBtn } from 'components/timer';
import axios from 'axios';

import React from 'react';

import { useState } from 'react';
import {Spinner} from '../../Spinner/Spinner';
const Input = (props) => (
	<InputMask
		mask='999999'
		value={props.value}
		maskChar={null}
		onChange={props.onChange}
		placeholder={'Смс код'}
	>
		{(inputProps) => {
			return (
				<Field
					{...inputProps}
					type='text'
					autoComplete='one-time-code'
					inputMode='numeric'
					name='code'
					className={props.className}
				/>
			);
		}}
	</InputMask>
);

export const SmsStep = ({
	phone,
	isNew,
	setStep,
	expired,
	setExpired,
	nextStep,
	smsError,
	setUser,
	setToken,
	pollComplete,
}) => {
    const [isLoad, setIsLoad] = useState(false)

    const hiddenPhone = phone.slice(0, -4) + '****';

	const [trigger, setTrigger] = useState(false);
	const smsCode = () => {
		return axios
			.post(`${process.env.REACT_APP_BACKEND}/auth/authenticate`, {
				phone,
        personal_data_confirmation: true
			})
			.then((e) => [setExpired(5), setTrigger(!trigger)]);
	};

	const parseResponse = (data) => {
		if (data.status === 200 && data.data?.is_poll_complete) {
			return setStep(3);
		}
		if (data.status === 200 && data.data?.is_new) {
			setToken(data.data.access_token);
			return nextStep();
		}
		setToken(data.data.access_token);
		setUser(data.data.data);
		return nextStep();
	};

	return (
		<section className='login login_sms'>
			<div className='login__content'>
				<p className='login__info'>Введите полученный в СМС код на Номер.</p>
				<p className='login__info'>{hiddenPhone}</p>
				<Formik
					initialValues={{ code: '' }}
					validate={(values) => {

						const errors = {};
						if (!values.code) {
							errors.code = 'Обязательное поле';
						}
						if (values.code && values.code.length < 6) {
							errors.code = 'Не правильный формат кода';
						}

						return errors;
					}}
					onSubmit={async (values, { setSubmitting, setFieldError , setErrors}) => {
                        setIsLoad(true)
						return axios
							.post(`${process.env.REACT_APP_BACKEND}/auth/token`, {
								code: values.code,
								phone: phone,
							})
							.then((data) => {
								parseResponse(data);
							}).catch((e) => setErrors(e.response.data.errors))
                            .finally(()=> setIsLoad(false))
					}}
				>
					{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						isValid,
						handleSubmit,
						isSubmitting,
					}) => (
						<Form
							className='login__form form form_sms js-form js-ajax-form'
							onSubmit={handleSubmit}
							autoComplete={'off'}
						>
							<div className='form__wrap'>
								<div className='form__wrap_sms'>
									<label htmlFor='phone' className='form__label'>
										<span style={{ color: '#636366' }}>6 символов из смс</span>
										<Input
											autoComplete={'off'}
											className={'form__input'}
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.code}
										/>
										<span className='authorization__error'>
											{errors.code && touched.code && errors.code}
										</span>
									</label>
									{/* <img src={Phone} alt='phone' /> */}
									<div className='form__repeat'>
										<TimedBtn
											initialMinute={expired}
											trigger={trigger}
											onClick={smsCode}
										/>
									</div>
								</div>

								<button
									className='form__button button'
									type='submit'
									disabled={isLoad}
								>

                                    {isLoad && <div className="form_loader"><Spinner/></div> }
                                    <span className="form__btn-text">Войти</span>
								</button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</section>
	);
};
